import { OptimizelyExperimentVariantType } from 'hooks/Optimizely/useOptimizelyExperiment'

export default function getOfferCtaText(variant?: OptimizelyExperimentVariantType) {
  switch (variant) {
    case 'variant_1':
      return 'See Deal'
    case 'variant_2':
      return 'Save Now'
    default:
      return 'View Offer'
  }
}
